import SingleImageElement from './SingleImageElement';
import DoubleImageElement from './DoubleImageElement';
import TextAndImageElement from './TextAndImageElement';
import ProjectQuote from '../Project/ProjectQuote/ProjectQuote';
import ProjectVideoModule from '../Project/ProjectVideoModule/ProjectVideoModule';
import ProjectImageModule from '../Project/ProjectImageModule/ProjectImageModule';
import {
  MultipleImageElementSchema,
  type PageElement,
  ProjectQuoteElementSchema,
  VideoElementSchema,
} from '../../content/schema/pageElements.val';
import DoubleImageElementNew from './DoubleImageElementNew';
import TextElementNew from './TextElementNew';
import LinksElement from './LinksElement';
import LinkListsElement from './LinkListsElement';
import ImageCarousel from './ImageCarousel';

const ProjectQuoteC = (props: ProjectQuoteElementSchema) => (
  <div className="mx-auto">
    <ProjectQuote author={props.author ?? undefined}>
      {props.quote}
    </ProjectQuote>
  </div>
);

const ProjectVideoC = (props: VideoElementSchema) => (
  <div className="mx-[-24px] laptop:mx-0">
    <ProjectVideoModule videoFile={props.video}></ProjectVideoModule>
  </div>
);

const ProjectImageModuleC = (props: MultipleImageElementSchema) => (
  <div>
    <ProjectImageModule images={props.images} />
  </div>
);

const PageElement = ({ element }: { element: PageElement }) => {
  switch (element.type) {
    case 'textElement':
      return (
        <TextElementNew
          title={element.title ?? undefined}
          text={element.text}
        />
      );
    case 'doubleImageElement':
      return (
        <DoubleImageElement
          images={[element.image1, element.image2]}
          size={element.size}
        />
      );
    case 'doubleImageElementNew':
      return (
        <DoubleImageElementNew
          images={[element.image1, element.image2]}
          text={element.text ?? undefined}
          centered={element.centered}
          layout={element.layout}
        />
      );
    case 'singleImageElement':
      return (
        <SingleImageElement
          image={element.image}
          size="xl"
          keepAspectRatio={element.keepAspectRatio || false}
        />
      );
    case 'textAndImageElement':
      return (
        <TextAndImageElement
          image={element.image}
          title={element.title}
          text={element.text}
          side={element.side}
        />
      );
    case 'linksElement':
      return <LinksElement links={element.links} />;
    case 'projectQuoteElement':
      return <ProjectQuoteC {...element} />;
    case 'videoElement':
      return (
        <div className="w-full max-lg-content">
          <ProjectVideoC {...element} />
        </div>
      );
    case 'multipleImageElement':
      return (
        <div className="w-full max-w-full">
          <ProjectImageModuleC {...element} />
        </div>
      );
    case 'linkListsElement':
      return (
        <div className="w-full max-w-full">
          <LinkListsElement lists={element.lists} />
        </div>
      );
    case 'imageCarouselElement':
      return (
        <div className="w-full max-w-full">
          <ImageCarousel images={element.images} />
        </div>
      );
    default:
      return <div></div>;
  }
};

export default PageElement;
